import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import ServicesItemBlockData from '../../../Models/Content/ServicesItemBlockData';
import {ImageProps} from 'app/utilities/ImageProps';

type ServicesItemProps = {
  item: ServicesItemBlockData;
  image: ImageProps;
};

const ServicesItemBlock = ({item, image}: ServicesItemProps) => {
  return (
    <div className='ServicesItemBlock'>
      <div className='ServicesItemBlock__image-and-button'>
        <Image className='ServicesItemBlock__image-and-button__image' {...image} />

        <a className='ServicesItemBlock__image-and-button__button' href={item.buttonLink.value}>
          {item?.buttonLinkTitle.value}
        </a>
      </div>

      <div className='ServicesItemBlock__title-and-description'>
        <h3 className='ServicesItemBlock__title-and-description__title'>{item?.title.value}</h3>

        <div className='ServicesItemBlock__title-and-description__description'>{item?.description.value}</div>
      </div>
    </div>
  );
};

export default ServicesItemBlock;
